"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelSVGDraw = exports.LABEL_SIZE = exports.Style = void 0;
var tslib_1 = require("tslib");
var model_1 = require("../../model");
var mithril_1 = require("../mithril");
var theme_1 = require("../theme");
var util_draw_svg_1 = require("./util.draw.svg");
function getComputedTextLengthSafe(textEl) {
    try {
        return textEl.getComputedTextLength();
    }
    catch (e) {
        return 0;
    }
}
var LABEL_ACCEPT_AND_DELETE_RADIUS = 8;
var DEFAULT_CHAR_WIDTH = 6;
var ELEMENT_NODE = 1;
// Character width mapping for Roboto Condensed at 14px font size
var ROBOTO_CONDENSED_CHAR_WIDTHS = {
    0: 7.8, 1: 7.8, 2: 7.8, 3: 7.8, 4: 7.8, 5: 7.8, 6: 7.8, 7: 7.8, 8: 7.8, 9: 7.8,
    A: 8.1, B: 7.9, C: 8.0, D: 8.3, E: 7.2, F: 6.8, G: 8.5, H: 8.2, I: 3.2, J: 5.8,
    K: 7.7, L: 6.5, M: 9.8, N: 8.2, O: 8.7, P: 7.5, Q: 8.7, R: 7.8, S: 7.5, T: 7.0,
    U: 8.0, V: 7.8, W: 11.2, X: 7.5, Y: 7.3, Z: 7.2,
    a: 6.8, b: 7.2, c: 6.5, d: 7.2, e: 6.8, f: 4.0, g: 7.2, h: 7.0, i: 3.0, j: 3.0,
    k: 6.3, l: 3.0, m: 10.5, n: 7.0, o: 7.0, p: 7.2, q: 7.2, r: 4.3, s: 6.2, t: 4.0,
    u: 7.0, v: 6.2, w: 9.0, x: 6.0, y: 6.2, z: 6.0,
    ' ': 3.5, '.': 3.0, ',': 3.0, '!': 3.5, '?': 6.5, ':': 3.0, ';': 3.0, '\'': 2.3, '"': 4.5,
    '-': 4.2, _: 5.5, '(': 4.2, ')': 4.2, '[': 3.8, ']': 3.8, '{': 4.5, '}': 4.5,
    '/': 5.2, '\\': 5.2, '|': 3.2, '@': 11.5, '#': 8.0, $: 7.8, '%': 11.0, '^': 6.5,
    '&': 8.5, '*': 5.5, '+': 7.3, '=': 7.3, '<': 7.3, '>': 7.3, '~': 7.8, '`': 4.0,
    '…': 7.0
};
function getCharWidth(char) {
    return ROBOTO_CONDENSED_CHAR_WIDTHS[char] || 6.5; // Default width for unmapped characters
}
/**
 * Calculates the total width of text using Roboto Condensed character widths
 */
function calculateTextWidth(text, fontSize) {
    if (fontSize === void 0) { fontSize = 14; }
    var scale = fontSize / 14;
    var width = 0;
    for (var i = 0; i < text.length; i++) {
        var char = text.charAt(i);
        width += getCharWidth(char) * scale;
    }
    return width;
}
/**
 * Truncates text for PDF export using Roboto Condensed character widths
 */
function truncateTextForPDF(text, maxWidth, fontSize) {
    if (fontSize === void 0) { fontSize = 14; }
    var ellipsisWidth = calculateTextWidth('…', fontSize);
    var availableWidth = maxWidth - ellipsisWidth;
    if (calculateTextWidth(text, fontSize) <= maxWidth) {
        return text;
    }
    var truncatedText = '';
    var currentWidth = 0;
    for (var i = 0; i < text.length; i++) {
        var char = text.charAt(i); // Use charAt instead of bracket notation
        var charWidth = getCharWidth(char) * (fontSize / 14);
        if (currentWidth + charWidth > availableWidth) {
            break;
        }
        truncatedText += char;
        currentWidth += charWidth;
    }
    return truncatedText + '…';
}
/** Line length to verify that it is not too long, in characters */
var ELLIPSIS_LINE_LENGTH = 25;
/** Length of a line that will have to be ...'d  */
var ELLIPSIS_LINE_MAX_LENGTH = 35;
exports.Style = (_a = {},
    _a[theme_1.ClassNames.label.text] = {
        'font-size': theme_1.StyleConfig.FONT_SIZE + 'px',
        'user-select': 'none',
        'pointer-events': 'none'
    },
    _a[theme_1.ClassNames.label.rect.container] = {
        fill: theme_1.StyleConfig.LABEL.FILL,
        stroke: 'none',
        'stroke-width': 0
    },
    _a[theme_1.ClassNames.label.rect.isHighlighted] = {
        fill: theme_1.StyleConfig.LABEL.FILL_HIGHLIGHTED
    },
    _a);
exports.LABEL_SIZE = {
    height: 5,
    width: 210
};
var LabelSVGDraw = /** @class */ (function () {
    function LabelSVGDraw() {
    }
    LabelSVGDraw.view = function (label, options) {
        var _a;
        var labelChildren = [];
        var parent = label.parent;
        var nodeId = label.id;
        var labelHeight = LabelSVGDraw.height(1);
        var isParentSelected = false;
        var isDeleteShown = false;
        var isAcceptShown = false;
        var spanColors = null;
        var backgroundRectAttrs = {};
        // Label text for each class of parent
        if (parent != null && (model_1.CollectionModelDrawableMarker.isMarker(parent) || model_1.CollectionModelDrawableMarkerOffset.isBaseOffset(parent))) {
            var text = options.draw.getLabelText(parent.id, options);
            spanColors = options.useColorCoding ? options.draw.getSpanColors(parent.id) : null;
            labelHeight = LabelSVGDraw.height(text.length);
            labelChildren.push(LabelSVGDraw.textLines(label, options, text));
            nodeId = parent.id;
            // If the label is for a base or base offset insight marker, set the text accordingly.
            if (parent instanceof model_1.CollectionModelDrawableMarker) {
                // if the detection class is zero offset, show the base selection text
                // if the detection class is an offset class other than zero_offset, show the base offset selection text
                // if its neither then leave it as null
                var baseSelectionText = ((_a = parent.insight) === null || _a === void 0 ? void 0 : _a.detection_class) === model_1.InsightMarkerDetectionClass.ZeroOffset
                    ? 'Select to Set Base'
                    : parent.isInsightBaseOffsetDetectionClass
                        ? 'Select to Set Base Offset'
                        : null;
                if (baseSelectionText && !parent.collectionHasBase) {
                    labelChildren.push(LabelSVGDraw.textLines(label, options, [baseSelectionText]));
                }
            }
            isDeleteShown = options.isInteractive &&
                options.isEditable &&
                parent.isDeletable &&
                options.draw.state.tool == null;
            isAcceptShown = isDeleteShown && !!options.isInsightMarkersVisible && label.isApprovableInsightDrawable();
        }
        else if (parent != null && model_1.CollectionModelDrawableLine.isLine(parent)) {
            nodeId = parent.id;
            var text = options.draw.getLabelText(parent.id, options);
            labelHeight = LabelSVGDraw.height(text.length);
            var selectedId = options.draw.state.selectedId;
            isParentSelected = selectedId === nodeId ||
                selectedId === parent.start.id ||
                selectedId === parent.end.id;
            labelChildren.push(LabelSVGDraw.textLines(label, options, text));
            isDeleteShown = options.isInteractive &&
                options.isEditable &&
                parent.isDeletable &&
                options.draw.state.tool == null;
            isAcceptShown = isDeleteShown && !!options.isInsightMarkersVisible && label.isInsightMeasurement;
        }
        else if (parent != null && parent instanceof model_1.CollectionModelDrawableVerticalSeparation) {
            backgroundRectAttrs.stroke = parent.clearanceThresholdInMeters ? parent.isInClearance ? 'lime' : 'red' : 'none';
            backgroundRectAttrs['stroke-width'] = theme_1.StyleConfig.STROKE_WIDTH * options.scale;
            labelChildren.push(LabelSVGDraw.textLines(label, options, label.getDisplayText(options)));
        }
        else {
            labelChildren.push(LabelSVGDraw.textLines(label, options, label.text));
        }
        var isSelected = options.draw.state.selectedId === nodeId || isParentSelected;
        var isHighlighted = options.draw.state.hoverId === nodeId;
        if (isDeleteShown && (isSelected || isHighlighted)) {
            labelChildren.push(LabelSVGDraw.deleteButton(options));
        }
        if (isAcceptShown && (isSelected || isHighlighted)) {
            labelChildren.push(LabelSVGDraw.acceptButton(options));
        }
        var classNames = [
            theme_1.ClassNames.label.container,
            isSelected ? theme_1.ClassNames.isSelected : null
        ].join(' ');
        var rectClassNames = [
            theme_1.ClassNames.label.rect.container,
            isSelected ? theme_1.ClassNames.label.rect.isSelected : null,
            isHighlighted ? theme_1.ClassNames.label.rect.isHighlighted : null,
            options.isInteractive ? theme_1.ClassNames.isMoveable : null
        ].join(' ');
        var fill = theme_1.StyleConfig.LABEL.FILL;
        if (options.isInsightMarkersVisible && label.isInsightMeasurement) {
            fill = theme_1.StyleConfig.LABEL.FILL_INSIGHT;
        }
        else if (isHighlighted) {
            fill = theme_1.StyleConfig.LABEL.FILL_HIGHLIGHTED;
        }
        else if (isSelected) {
            fill = theme_1.StyleConfig.LABEL.FILL_SELECTED;
        }
        if (spanColors) {
            labelChildren.push(LabelSVGDraw.rectSpansColors(spanColors, labelHeight, isHighlighted, options));
        }
        var width = options.scale * exports.LABEL_SIZE.width;
        var height = options.scale * labelHeight;
        var backgroundRect = (0, mithril_1.m)('rect', tslib_1.__assign({ className: rectClassNames, x: '0', y: '0', width: width, height: height, fill: fill, 'fill-opacity': isHighlighted ? 0.9 : 0.75, 'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.LABEL, 'c-Draw-draggable': 'true' }, backgroundRectAttrs));
        var labelBox = (0, mithril_1.m)('g', {
            transform: "translate(".concat(label.x, ", ").concat(label.y, ")")
        }, [
            tslib_1.__spreadArray([backgroundRect], tslib_1.__read(labelChildren), false)
        ]);
        return (0, mithril_1.m)('g', {
            // key: currentState.id,
            className: classNames,
            'c-Draw-node-id': nodeId,
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.LABEL
        }, tslib_1.__spreadArray([
            labelBox
        ], tslib_1.__read(LabelSVGDraw.DrawConnectingLineToParent(label, parent, options)), false));
    };
    LabelSVGDraw.DrawConnectingLineToParent = function (label, parent, options) {
        var parentConnectionPoint = parent.getLabelConnectionPoint(options);
        // If the label is on the left, set the label connection point to be the middle of the right side of the label.
        // Otherwise, set it to the middle of the left side of the label.
        var labelConnectionPoint = {
            x: label.isOnLeftSide()
                ? label.x + options.scale * LabelSVGDraw.Size.width // Right
                : label.x + 5, // Left
            y: label.y + options.scale * LabelSVGDraw.height(label.text.length) / 2
        };
        // Draw the line connecting the label to the parent.
        return [
            util_draw_svg_1.SVGUtil.DrawLineMain(parentConnectionPoint, labelConnectionPoint, options.scale),
            util_draw_svg_1.SVGUtil.DrawLineSecondary(parentConnectionPoint, labelConnectionPoint, options.scale, parent.isInsightMeasurement ? theme_1.StyleConfig.STOKE_SECONDARY_INSIGHT : theme_1.StyleConfig.STROKE_SECONDARY)
        ];
    };
    LabelSVGDraw.rectSpansColors = function (spanColors, labelHeight, isHighlighted, options) {
        var width = options.scale * exports.LABEL_SIZE.width;
        var height = options.scale * labelHeight;
        var colorRects = [];
        spanColors.forEach(function (color, index) {
            var colorRect = (0, mithril_1.m)('rect', {
                x: (width * 0.015 * index),
                y: '0',
                width: width * 0.015,
                height: height,
                fill: color,
                'fill-opacity': isHighlighted ? 1 : 0.85
            });
            colorRects.push(colorRect);
        });
        return colorRects;
    };
    LabelSVGDraw.height = function (lineCount) {
        return exports.LABEL_SIZE.height +
            (theme_1.StyleConfig.FONT_SIZE + 0.25 * theme_1.StyleConfig.FONT_SIZE) * (lineCount || 1);
    };
    LabelSVGDraw.textLines = function (node, options, lines) {
        var _a;
        var longestLine = 0;
        var output = [];
        for (var i = 0; i < lines.length; i++) {
            var line = (_a = lines[i]) !== null && _a !== void 0 ? _a : '';
            var text = LabelSVGDraw.text(node, options, line, i);
            text.attrs.y = (1 + i * 1.25) + 'em';
            longestLine = Math.max(longestLine, line.length);
            output.push(text);
        }
        var displayAsInsight = options.isInsightMarkersVisible && node.isInsightMeasurement;
        var xOffset = exports.LABEL_SIZE.width * options.scale / 2;
        var attrs = {
            transform: "translate(".concat(xOffset, ", ").concat(-6 * options.scale / 4, ")scale(").concat(options.scale, ")"),
            fill: options.isInsightMarkersVisible && displayAsInsight ? theme_1.StyleConfig.FONT_COLOR_INSIGHT : theme_1.StyleConfig.FONT_COLOR
        };
        if (options.isInteractive && longestLine > ELLIPSIS_LINE_LENGTH) {
            var ellipsisText = function (el) { return LabelSVGDraw.ellipsisText(el); };
            attrs['oncreate'] = ellipsisText;
            attrs['onupdate'] = ellipsisText;
        }
        return (0, mithril_1.m)('g', attrs, output);
    };
    LabelSVGDraw.text = function (node, options, line, offset) {
        var outputLine = line;
        // Truncate text only for PDF, for browser is done differently
        if (options.isInteractive === false) {
            var maxWidth = exports.LABEL_SIZE.width * 0.95; // 95% of label width for padding
            outputLine = truncateTextForPDF(line, maxWidth, theme_1.StyleConfig.FONT_SIZE);
        }
        return (0, mithril_1.m)('text', {
            className: theme_1.ClassNames.label.text,
            style: exports.Style[theme_1.ClassNames.label.text],
            y: '1em',
            x: "0",
            width: options.scale * exports.LABEL_SIZE.width,
            'text-anchor': 'middle',
            dy: '0.25em',
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.LABEL,
            key: offset
        }, outputLine);
    };
    LabelSVGDraw.ellipsisText = function (_a) {
        var dom = _a.dom;
        var parentWidth = exports.LABEL_SIZE.width * 0.9;
        for (var i = 0; i < dom.childNodes.length; i++) {
            var textEl = dom.childNodes[i];
            if (textEl.nodeType !== ELEMENT_NODE) {
                continue;
            }
            var textNode = textEl.firstChild;
            if (textNode == null) {
                continue;
            }
            // Skip short lines
            if (textNode.textContent.length < ELLIPSIS_LINE_LENGTH) {
                continue;
            }
            // Skip text that has already been processed
            if (textNode.textContent.indexOf('…') > -1) {
                continue;
            }
            if (textNode.$lastText === textNode.textContent) {
                continue;
            }
            var computedLength = getComputedTextLengthSafe(textEl) || DEFAULT_CHAR_WIDTH * textNode.textContent.length;
            var addDots = computedLength > parentWidth;
            // If text lines are really long, just assume we will need to truncate it
            if (textNode.textContent.length > ELLIPSIS_LINE_MAX_LENGTH) {
                var textSizePerCharacter = computedLength / textNode.textContent.length;
                var maxNumberOfChars = Math.floor(parentWidth / textSizePerCharacter);
                textNode.textContent = textNode.textContent.slice(0, maxNumberOfChars);
            }
            while (computedLength > parentWidth) {
                textNode.textContent = textNode.textContent.slice(0, textNode.textContent.length - 2);
                computedLength = getComputedTextLengthSafe(textEl) || DEFAULT_CHAR_WIDTH * textNode.textContent.length;
            }
            if (addDots && textNode.textContent.indexOf('…') === -1) {
                textNode.textContent = textNode.textContent + '…';
            }
            else {
                textNode.$lastText = textNode.textContent;
            }
        }
    };
    LabelSVGDraw.deleteButton = function (options) {
        var radius = options.scale * LABEL_ACCEPT_AND_DELETE_RADIUS;
        var XSize = radius / 2;
        var y = radius * 1.25;
        var x = options.scale * exports.LABEL_SIZE.width - radius * 1.25;
        var strokeWidth = options.scale * theme_1.StyleConfig.STROKE_WIDTH;
        var X1 = (0, mithril_1.m)('line', {
            x1: x - XSize,
            y1: y - XSize,
            x2: x + XSize,
            y2: y + XSize,
            stroke: theme_1.StyleConfig.BUTTON.DELETE_STROKE,
            'stroke-width': strokeWidth,
            'pointer-events': 'none'
        });
        var X2 = (0, mithril_1.m)('line', {
            x1: x + XSize,
            y1: y - XSize,
            x2: x - XSize,
            y2: y + XSize,
            stroke: theme_1.StyleConfig.BUTTON.DELETE_STROKE,
            'stroke-width': strokeWidth,
            'pointer-events': 'none'
        });
        var circle = (0, mithril_1.m)('circle', {
            cx: x,
            cy: y,
            r: radius,
            fill: '#fafafa',
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.DELETE
        });
        return (0, mithril_1.m)('g', {
            className: theme_1.ClassNames.label.delete,
            transform: "translate(".concat(-8 * options.scale / 4, ", ").concat(5 * options.scale / 4, ")")
        }, [circle, X1, X2]);
    };
    LabelSVGDraw.acceptButton = function (options) {
        var radius = options.scale * LABEL_ACCEPT_AND_DELETE_RADIUS;
        var checkSymbolSize = radius / 2;
        var y = radius * 1.25;
        var x = radius * 1.25;
        var strokeWidth = options.scale * theme_1.StyleConfig.STROKE_WIDTH;
        var shortStroke = (0, mithril_1.m)('line', {
            x1: x - checkSymbolSize,
            y1: y,
            x2: x - (checkSymbolSize * 0.5) + (strokeWidth * 0.5),
            y2: y + (checkSymbolSize * 0.75),
            stroke: theme_1.StyleConfig.BUTTON.ACCEPT_STROKE,
            'stroke-width': strokeWidth,
            'pointer-events': 'none'
        });
        var longStroke = (0, mithril_1.m)('line', {
            x1: x - (checkSymbolSize * 0.5),
            y1: y + (checkSymbolSize * 0.75),
            x2: x + checkSymbolSize,
            y2: y - checkSymbolSize,
            stroke: theme_1.StyleConfig.BUTTON.ACCEPT_STROKE,
            'stroke-width': strokeWidth,
            'pointer-events': 'none'
        });
        var circle = (0, mithril_1.m)('circle', {
            cx: x,
            cy: y,
            r: radius,
            fill: '#fafafa',
            'c-Draw-Label': util_draw_svg_1.IkeDrawLabel.ACCEPT
        });
        return (0, mithril_1.m)('g', {
            className: theme_1.ClassNames.label.accept,
            transform: "translate(".concat(8 * options.scale / 4, ", ").concat(5 * options.scale / 4, ")")
        }, [circle, shortStroke, longStroke]);
    };
    LabelSVGDraw.Size = exports.LABEL_SIZE;
    return LabelSVGDraw;
}());
exports.LabelSVGDraw = LabelSVGDraw;
//# sourceMappingURL=label.draw.svg.js.map